import { render } from "./vdepartment.vue?vue&type=template&id=38427690&scoped=true"
import script from "./vdepartment.vue?vue&type=script&lang=js"
export * from "./vdepartment.vue?vue&type=script&lang=js"

import "./vdepartment.vue?vue&type=style&index=0&id=38427690&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38427690"]])

export default __exports__